import type { Mesure } from "./contract";

/**
 * Envoie une mesure au backend (`POST /api/mesure`), sans l'attendre et sans jamais lever :
 * une partie ne depend jamais du reseau.
 *
 * `credentials: "omit"` : la requete ne porte aucun cookie, et le navigateur ignore celui
 * que la couche Lab du backend pose sur ses reponses. L'appli ne depose donc aucun cookie.
 * `keepalive` : la mesure part meme si l'onglet se ferme juste apres.
 */
export function envoyerMesure(mesure: Mesure): void {
  try {
    void fetch("/api/mesure", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(mesure),
      credentials: "omit",
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Pas de reseau, ou fetch refuse : la mesure est perdue, la partie continue.
  }
}
